import { QM } from '../types'

const initialState = {
  dialogOpen: false,
  isLoading: false,
  uploadSuccess: false,
  error: null,
  thresholdUpdates: null,
  thresholdMessage: null,
}

export default function qm(state = initialState, action) {
  switch (action.type) {
    case QM.OPEN_DIALOG:
      return { ...initialState, dialogOpen: true }

    case QM.UPLOAD_FETCHING:
      return {
        ...state,
        isLoading: true,
        error: null,
        uploadSuccess: false,
      }

    case QM.UPLOAD_SUCCESS:
      return {
        ...state,
        isLoading: false,
        uploadSuccess: true,
        thresholdUpdates: action.payload.thresholdUpdates,
        thresholdMessage: action.payload.thresholdMessage,
      }

    case QM.UPLOAD_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      }

    case QM.CLOSE_DIALOG:
      return { ...state, dialogOpen: false }

    case QM.RESET:
      return initialState

    default:
      return state
  }
}
